import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { NavbarComponent } from './navbar/navbar.component';
import { childTokenGuard } from './Guards/child-token.guard';
import { RefreshComponent } from './refresh/refresh.component';
import { ResetPasswordNewComponent } from './reset-password-new/reset-password-new.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AppointmentListComponent } from './appointment/appointment-list/appointment-list.component';
import { AppointmentCreateComponent } from './appointment/appointment-create/appointment-create.component';
import { CompanyListComponent } from './masters/company/company-list/company-list.component';
import { VesselListComponent } from './masters/vessel/vessel-list/vessel-list.component';
import { ProfileListComponent } from './masters/profile/profile-list/profile-list.component';
import { ProfileCreateComponent } from './masters/profile/profile-create/profile-create.component';
import { BranchListComponent } from './masters/company/branch-list/branch-list.component';
import { BranchCreateComponent } from './masters/company/branch-create/branch-create.component';
import { RankListComponent } from './masters/rank/rank-list/rank-list.component';
import { InvoiceListComponent } from './appointment/invoice-list/invoice-list.component';
import { InvoiceCreateComponent } from './appointment/invoice-create/invoice-create.component';
import { ScaleCreateComponent } from './masters/scale/scale-create/scale-create.component';
import { ScaleListComponent } from './masters/scale/scale-list/scale-list.component';
import { CategoryCreateComponent } from './masters/category/category-create/category-create.component';
import { CategoryListComponent } from './masters/category/category-list/category-list.component';
import { QuestionCreateComponent } from './masters/questionbank/question-create/question-create.component';
import { QuestionListComponent } from './masters/questionbank/question-list/question-list.component';
import { QuestionTranslationComponent } from './masters/questionbank/question-translation/question-translation.component';
import { UserAnsComponent } from './appointment/user-ans/user-ans.component';
import { UserScoreComponent } from './appointment/user-score/user-score.component';
import { ReportComponent } from './appointment/report/report.component';

const routes: Routes = [
	{ path: '', redirectTo: '/login', pathMatch: 'full' },
	{ path: 'refresh', component: RefreshComponent },
	{ path: 'login', component: LoginComponent },
	{ path: 'forgot-password', component: ResetPasswordNewComponent },
	{
		path: 'app', component: NavbarComponent, canActivate: [childTokenGuard], children: [
			{ path: 'dashboard', component: DashboardComponent, data: { animation: 2 } },
			{ path: 'appointmentList', component: AppointmentListComponent, data: { animation: 3 } },
			{ path: 'create-appointment', component: AppointmentCreateComponent, data: { animation: 4 } },
			{ path: 'edit-appointment/:refNo', component: AppointmentCreateComponent, data: { animation: 4 } },
			{ path: 'company-list', component: CompanyListComponent, data: { animation: 6 } },
			{ path: 'profile-list', component: ProfileListComponent, data: { animation: 7 } },
			{ path: 'create-profile', component: ProfileCreateComponent, data: { animation: 8 } },
			{ path: 'edit-profile/:uId', component: ProfileCreateComponent, data: { animation: 8 } },
			{ path: 'rank-list', component: RankListComponent, data: { animation: 9 } },
			{ path: 'scale-list', component: ScaleListComponent, data: { animation: 10 } },
			{ path: 'create-scale', component: ScaleCreateComponent, data: { animation: 11 } },
			{ path: 'edit-scale/:uId', component: ScaleCreateComponent, data: { animation: 11 } },
			{ path: 'category-list', component: CategoryListComponent, data: { animation: 12 } },
			{ path: 'create-category', component: CategoryCreateComponent, data: { animation: 13 } },
			{ path: 'edit-category/:uId', component: CategoryCreateComponent, data: { animation: 13 } },
			{ path: 'question-list', component: QuestionListComponent, data: { animation: 14 } },
			{ path: 'create-question', component: QuestionCreateComponent, data: { animation: 15 } },
			{ path: 'edit-question/:Id', component: QuestionCreateComponent, data: { animation: 15 } },
			{ path: 'userans/:Id', component: UserAnsComponent, data: { animation: 16 } },
			{ path: 'userscore/:Id', component: UserScoreComponent, data: { animation: 17 } },
			{ path: 'report/:refNo', component: ReportComponent, data: { animation: 17 } },
		]
	},
	{ path: '**', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
